module.exports = __webpack_public_path__ + "img/gujuncai_p.270f7487.png";